import { EXIT_INTENT_EXPERIMENT_NAME } from './exit-intent/constants';
import type {
  FunnelExperimentConfig,
  JumpPageExperimentConfig,
  PrimaryGoalExperimentConfig,
  RecommendationsExperimentConfig,
} from './types';

export const STATIC_EXPERIMENTS: (
  | PrimaryGoalExperimentConfig
  | FunnelExperimentConfig
  | JumpPageExperimentConfig
  | RecommendationsExperimentConfig
)[] = [
  /*
  Blocked until exit intent experiment is complete
  { pageType: 'primary-goal', name: CREDIT_SCORE_FIRST_EXPERIMENT_NAME },
  {
    pageType: 'funnel',
    name: CREDIT_SCORE_FIRST_EXPERIMENT_NAME,
    slugs: CREDIT_SCORE_FIRST_EXPERIMENT_SLUGS,
  },
  { pageType: 'recommendations', name: CREDIT_SCORE_FIRST_EXPERIMENT_NAME },
  */
  { pageType: 'primary-goal', name: EXIT_INTENT_EXPERIMENT_NAME },
  { pageType: 'funnel', name: EXIT_INTENT_EXPERIMENT_NAME },
  // { pageType: 'funnel', name: EXPLORE_OTHER_CARD_TYPES_EXPERIMENT_NAME },
];
